<template>
    <div class="v-project">
        <el-image 
         v-if="cp_isShow"
         :src="pr_data.thumb"
         lazy 
         fit="scale-down"
         class="project-image"></el-image>
        <div class="project-info" v-if="cp_isShow">
            <p class="info-title">{{pr_data.gname}}</p>
            <p>作者: {{pr_data.author_name}}</p>
            <p>作品字数: {{pr_data.release_word_sum}}</p>
            <p>作品状态: {{complete_flag[pr_data.complete_flag]}}</p>
        </div>

    </div>
</template>

<script>

export default {
    props: {
        pr_data: {
            type : Object,
            default: ()=> {}
        }
    },
    computed: {
        cp_isShow() {
            return JSON.stringify(this.pr_data) == "{}" ? false : true;
        }
    },
    data() {
        return {
            complete_flag: {  //【作品状态】包括：连载中，完结，精修中，部分完结
                0: '未完结',
                1: '完结',
                2: '连载中',
                3: '精修中',
                4: '待上映'
            }
        }
    }
}
</script>

<style scoped lang="less">
    .v-project {
        cursor: pointer;
        float: left;
        width:450px;
        height: 221px;
        padding-bottom: 20px;
        margin-bottom: 20px;
        border-bottom: 1px solid #ebeef5;
        overflow: hidden;
         .project-image{
            width: 150px;
            height: 200px;
            float: left;
         }
         .project-info {
            float: left;
            width: 280px;
            margin:0 10px;
            padding-right: 10px;
            p {
                padding: 10px 0;
                font-size:14px;
            }
            .info-title {
                padding-top:0; 
                font-size:16px;
                font-weight: bold;
            }
            
         }
    }
</style>